var render = function render(){var _vm=this,_c=_vm._self._c;return _c('custom-table',{ref:"table",attrs:{"table-set":_vm.tableCondition,"service-function":_vm.serviceFunction,"first-parameters":_vm.getFirstParameters(),"router-name":"/risk/fraud-notification"}})
}
var staticRenderFns = []

export { render, staticRenderFns }